module.exports = __webpack_public_path__ + "img/web_28.fc005c37.png";